// Auto-advancing "Our Brands" carousel. How many logos show at once (4 on
// desktop, 2 on mobile) is purely a CSS concern (see brands-strip.css); this
// only shifts the track by one logo's rendered width per tick, so the same
// logic drives both layouts without needing to know which is active.
//
// The full logo set is cloned once and appended after the real one. Sliding
// into that clone and then resetting to translateX(0) with transitions off
// is what makes the loop feel continuous instead of snapping backward.
const ADVANCE_MS = 2500;
const TRANSITION_MS = 600;

export function initBrandsCarousel() {
  const carousel = document.querySelector('[data-brands-carousel]');
  const track = document.querySelector('[data-brands-carousel-track]');
  if (!carousel || !track) return;

  const items = Array.from(track.children);
  if (items.length <= 1) return;

  for (const item of items) {
    const clone = item.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    // Not `inert`: that would also block pointer clicks on the clone's
    // link, and the clone is on-screen (not just an off-screen loop
    // buffer) for most of the cycle. tabindex="-1" keeps it out of tab
    // order/AT while leaving it clickable — its href is identical to the
    // real item's anyway.
    clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
    track.appendChild(clone);
  }

  let step = 0;
  let timer;

  function itemWidth() {
    return track.children[0].getBoundingClientRect().width;
  }

  function goTo(px, animate) {
    track.style.transition = animate ? `transform ${TRANSITION_MS}ms ease` : 'none';
    track.style.transform = `translateX(-${px}px)`;
  }

  function advance() {
    step += 1;
    goTo(step * itemWidth(), true);

    if (step === items.length) {
      window.setTimeout(() => {
        step = 0;
        goTo(0, false);
      }, TRANSITION_MS);
    }
  }

  function start() {
    timer = window.setInterval(advance, ADVANCE_MS);
  }

  function stop() {
    window.clearInterval(timer);
  }

  window.addEventListener('resize', () => goTo(step * itemWidth(), false));

  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);

  start();
}
